<template>
  <div
    id="reset-password-request-form"
    class="box auth"
    @keyup.enter="resetPasswordRequest()"
  >
    <h1 class="title is-size-3 has-text-centered">
      {{ $t('reset_password_form.title') }}
    </h1>

    <div class="content is-small">
      <p>{{ $t('reset_password_form.journeys_request_description') }}</p>
    </div>

    <div
      class="message is-small is-danger animated fast fadeIn"
      v-if="errorMessage"
    >
      <div class="message-body">{{ $t(errorMessage) }}</div>
    </div>

    <div
      class="message is-small is-success animated fast fadeIn"
      v-if="hasSentEmail"
    >
      <div class="message-body">
        <p>{{ $t('reset_password_form.success.email_link') }}</p>
        <p>{{ $t('reset_password_form.success.close') }}</p>
      </div>
    </div>

    <div class="field">
      <label for="email" class="label">{{
        $t('reset_password_form.email_label')
      }}</label>
      <div class="control">
        <input
          type="email"
          id="email"
          class="input is-shadowless"
          autocomplete="email"
          required
          autofocus
          v-model="email"
        />
      </div>
    </div>

    <div class="field field-action">
      <div class="control">
        <gradient-button
          :title="$t('reset_password_form.reset_password_request_button')"
          :is-inline="true"
          :is-loading="isLoading"
          @click.native="resetPasswordRequest()"
        ></gradient-button>
        <div class="help">
          {{ $t('reset_password_form.sign_in_link.prefix') }}
          <router-link to="login" class="has-text-info">{{
            $t('reset_password_form.sign_in_link.label')
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from 'services/Auth';
import router from 'router';
import { GradientButton } from 'components/buttons';
import { isEmailValid } from 'utils/auth';

export default {
  components: {
    GradientButton,
  },

  data() {
    return {
      email: '',
      hasSentEmail: false,
      errorMessage: '',
      isLoading: false,
    };
  },

  methods: {
    resetPasswordRequest() {
      if (this.isLoading) {
        return;
      }

      if (this.email === '') {
        this.errorMessage = 'reset_password_form.errors.empty_field';
        return;
      }

      if (!isEmailValid(this.email)) {
        this.errorMessage = 'register_form.errors.invalid_email';
        return;
      }

      this.isLoading = true;
      this.errorMessage = '';
      this.hasSentEmail = false;

      Auth.resetPasswordRequest(this.email)
        .then(() => {
          this.hasSentEmail = true;
          this.errorMessage = '';
        })
        .catch(err => {
          this.errorMessage =
            err.message || 'reset_password_form.errors.reset_password_failed';
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
